import _ from "lodash";
import React, {CSSProperties} from "react";
import styles from "./style.module.scss";

interface IProps {
  list: {
    text?: string;
    value: string;
  }[];
  value: string;
  setValue?: (value: string) => void;
  containerStyle?: CSSProperties;
}

export default function RadioBox({
  list,
  value,
  setValue,
  containerStyle,
}: IProps) {
  const radioName = _.uniqueId();

  return (
    <div className={styles.container} style={containerStyle}>
      {list.map(item => (
        <label key={_.uniqueId()} className={styles.item}>
          <label
            className={styles.radioWrapper}
            onClick={() => setValue?.(item.value)}>
            <input
              type="radio"
              name={radioName}
              value={item.value}
              defaultChecked={item.value === value}
            />
            <span></span>
          </label>
          <span>{item.text || item.value}</span>
        </label>
      ))}
    </div>
  );
}
